module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"prolongationFailed":"Последняя попытка продления подписки была безуспешной","youCan":"Вы можете","replaceActiveCard":"Заменить активную карту","tryToCharge":"Попробовать еще раз оплатить с активной карты","prolongSubscription":"Продлить подписку","change":"Изменить"}}')
  delete Component.options._Ctor
}
